import type { AppConfig } from '#/config/types/AppConfig';
import { postJson } from '#/utils/http/postJson';
import { invariant } from '#/utils/invariant';

/**
 * Algolia Analytics tracking. Note that position is 1-indexed
 * This function is a no-op if ALGOLIA_ANALYTICS_API_KEY is not set
 * i.e., sandboxes algolia environments like dev
 */
export function algoliaTrackClick({
  queryID,
  objectID,
  position,
  appConfig,
}: {
  queryID: string | undefined;
  objectID: string;
  position: number;
  appConfig: AppConfig;
}) {
  if (!queryID) return;

  invariant(objectID, 'No object id supplied');
  invariant(position !== undefined, 'Invalid position supplied');

  const ANALYTICS_KEY = appConfig.algolia.analyticsApiKey;

  const headers = {
    'X-Algolia-API-Key': ANALYTICS_KEY ?? undefined,
    'X-Algolia-Application-Id': appConfig.algolia.appId ?? undefined,
  };
  const data = {
    queryID,
    objectID,
    position,
  };

  if (ANALYTICS_KEY) {
    return postJson('/algolia-ins8s/1/searches/click', data, { headers });
  }
}
